/**
 * InstantSearchPortal Component
 */

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { IInstantSearchExposedProps, InstantSearch } from './';

export class InstantSearchPortal extends React.Component<IInstantSearchExposedProps> {
  render() {
    const selector = document.getElementsByClassName('instant-search-wrapper');
    return selector.length ? ReactDOM.createPortal(
      <InstantSearch {...this.props} />,
      selector[0],
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/InstantSearch/portal.tsx